export class MhahPkgConstants {
  GanaMatched = [
    [6, 6, 0],
    [5, 6, 0],
    [1, 0, 6],
  ];
}
